<template id="">
    <div id="step-1" class="d-flex flex-column h-100 align-items-center w-100 ">

        <div class="d-flex flex-column justify-content-start align-items-center w-100 mt-8 mt-md-12 mb-10 mb-lg-12 mb-xl-18">
            <div class="d-flex align-items-center justify-content-start w-100">
                <span class="counter text-white bg-primary mr-4">1</span>
                <h3 class="text-white mb-0 text-uppercase">Select your usage</h3>
            </div>
        </div>

        <div class="d-flex mt-11 mt-lg-0">
            <a v-for="option in options" :key="option.id"
                v-on:click.prevent="updateValue(option)"
                class="page--hybrid-selector__box green m-2"
                :class="[option.cssClass]"
                href="#" >
                <h3 class="text-white mb-0">{{ option.name }}</h3>
            </a>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            options: [
                {
                    id: 'silage',
                    name: 'Silage',
                    cssClass: 'green',
                },
                {
                    id: 'grain',
                    name: 'Grain',
                    cssClass: 'yellow',
                },
            ]
        }
    },

    props: ['value', 'formSummary'],

    computed: {

    },

    methods: {
        updateValue(option) {
            this.$emit('input', option);

        }
    },
}
</script>
